import { supabase } from '@/integrations/supabase/client';

export interface MemberGroup {
  cargoName: string;
  cargoColor: string | null;
  cargoIcon: string;
  priority: number;
  members: {
    user_id: string;
    display_name: string | null;
    avatar_url: string | null;
    member_color: string | null;
    member_color_secondary: string | null;
  }[];
}

export async function fetchActiveMembersGrouped(): Promise<MemberGroup[]> {
  const { data, error } = await supabase.rpc('get_active_members_grouped');
  if (error) {
    console.error('Error fetching active members:', error);
    return [];
  }
  return (data as unknown as MemberGroup[]) ?? [];
}

/** Wrapper for use as a bare queryFn (no args) */
export const fetchActiveMembersGroupedDefault = fetchActiveMembersGrouped;
